export default {
  label: {
    display: "flex",
    alignItems: "center",
    gap: "1ex",
    mb: "calc(0.5 * var(--rhythm))",
  },
};
